export const filtrosRetrabalho = [
  "correção",
  "corrigindo",
  "ajustado",
  "ajuste",
  "ajustando",
  "hotfix",
  "erro",
  "corrigido",
  "debugando",
  "correções",
];
